"use strict";
/*
  That is a copy of https://github.com/bfred-it/supports-webp
  Changes:
  - added additional check for case when toDataURL returns null

  Some facts about canvas.toDataURL(mimeType):
  - returns DataURL of encoded image from the canvas.
  - use "image/png" as fallback if mimeType isn't supported.
  - can return null in some canvas implementations
*/
Object.defineProperty(exports, "__esModule", { value: true });
var canvas = typeof document === 'object' ? document.createElement('canvas') : {};
canvas.width = canvas.height = 1;
var dataUrl = (canvas.toDataURL && canvas.toDataURL('image/webp')) || '';
exports.default = dataUrl.indexOf('image/webp') === 5;
//# sourceMappingURL=supportsWebP.js.map